import { Button } from "../../../components/ui/button";
import { useAuthStore } from "../../../stores/auth";
import { Header } from "../../../components/layout/header";
import { LogOut } from "lucide-react";
import { Main } from "../../../components/layout/main";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
const Task: React.FC = () => {
    const { logout } = useAuthStore();
    const navigate = useNavigate();


    const isUpdatePage = useLocation().pathname.includes("update-task");
    const isCreatePage = useLocation().pathname.includes("create-task");

    return (
        <>
            <Header fixed className='flex justify-between w-[inherit]'>
                <div className='mr-0 flex items-center justify-end space-x-4 w-[inherit]'>
                    <Button variant="outline" size="icon" onClick={logout}>
                        <LogOut />
                    </Button>
                </div>
            </Header>

            <Main>
                <h4 className="text-xl font-semibold">
                    <span className="hover:underline cursor-pointer" onClick={() => navigate(-1)}>
                        Task
                    </span>
                    {isUpdatePage ? " / Update" : isCreatePage ? " / Create" : ""}
                </h4>

                <div className="flex gap-4 mt-4 w-full flex-wrap">
                    <Outlet />
                </div>

            </Main>
        </>
    )
}

export default Task;